import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBecepsRightArm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBecepsRightArm"><Path d="M12.2488 12.9258C15.1667 7.77778 21.5025 9.79401 21.5 14.8024C21.5 23.1247 7.63856 22.6 2.81532 19.0969C1.24412 10.1664 5.7965 2.5 10.8897 2.5C16.0088 2.5 12.819 9.59753 8.96059 6.28535" stroke="currentColor" strokeLinejoin="round"/><Path d="M14.888 14.05C12.5185 12.2719 9.51733 13.2708 7.5 15C8.81715 12.1123 7.39117 10.7993 10 7" stroke="currentColor"/></CentralIconBase>;
});

export default IconBecepsRightArm;
